import {
  FormEvent,
  InputHTMLAttributes,
  PureComponent,
  ReactNode,
} from 'react';

import { InjectedIntl, injectIntl } from 'react-intl';

import CrossIcon from '@atlaskit/icon/core/migration/cross';
import SearchIcon from '@atlaskit/icon/core/migration/search';
import Textfield from '@atlaskit/textfield';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';

import { srOnlyStyles } from 'src/components/accessibility';
import messages from 'src/i18n/common';

import * as styles from './search-field.style';

type Props = {
  currentSearch: string | null | undefined;
  handleFilterChange: (e: FormEvent<HTMLInputElement>) => void;
  intl: InjectedIntl;
  placeholder?: string;
  clearFilter?: () => void;
  fieldName?: string;
  onFocus?: () => void;
  onBlur?: () => void;
  forwardedRef?: (
    el: InputHTMLAttributes<HTMLInputElement> | null | undefined
  ) => void;
  elemBeforeInput?: ReactNode;
  width?: string;
  isDisabled?: boolean;
  tooltipContent?: string;
};

class SearchField extends PureComponent<Props> {
  render() {
    const {
      currentSearch,
      handleFilterChange,
      placeholder,
      clearFilter,
      fieldName,
      intl,
      onFocus,
      onBlur,
      forwardedRef,
      elemBeforeInput,
      width,
      isDisabled,
      tooltipContent,
    } = this.props;

    const textField = (
      <Textfield
        autoComplete="off"
        name={fieldName}
        id={fieldName}
        value={currentSearch || ''}
        onChange={handleFilterChange}
        placeholder={placeholder}
        onFocus={onFocus}
        onBlur={onBlur}
        isDisabled={isDisabled}
        ref={forwardedRef}
        elemBeforeInput={elemBeforeInput}
        elemAfterInput={
          clearFilter &&
          (currentSearch ? (
            <styles.ClearFilterButton
              aria-label={intl.formatMessage(messages.clearFilter)}
              appearance="subtle"
              spacing="none"
              onClick={clearFilter}
              iconAfter={<CrossIcon label="" LEGACY_size="small" />}
            />
          ) : (
            <styles.SearchIconWrapper>
              <SearchIcon
                label=""
                LEGACY_size="small"
                color={token('color.text.subtlest')}
              />
            </styles.SearchIconWrapper>
          ))
        }
      />
    );

    return (
      <styles.SearchFieldWrapper role="search" width={width}>
        <label className={srOnlyStyles} htmlFor={fieldName}>
          {placeholder}
        </label>
        {tooltipContent ? (
          <Tooltip content={tooltipContent} position="top">
            {textField}
          </Tooltip>
        ) : (
          textField
        )}
      </styles.SearchFieldWrapper>
    );
  }
}

export default injectIntl(SearchField);
